// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2vKLd","confetti":"styles_confetti__22gBY","title":"styles_title__1S9u1","sectionContainer":"styles_sectionContainer__1jQKr"};